module.exports = __webpack_public_path__ + "static/media/n2.84fa927c.png";